import { SecurityMasterLoadError } from 'src/services/SecurityMasterService/SecurityMasterLoadError';
import { ZodError } from 'zod';

/**
 * Structured-clone-safe form of a master load failure — Error instances lose
 * their class identity across `postMessage`, so the transient/unexpected
 * classification the retry policy needs must travel explicitly.
 */
export interface SecurityMasterLoadFailure {
    name: string;
    message: string;
    /** Whether the load query should retry with backoff. */
    transient: boolean;
}

export function serializeLoadFailure(error: unknown): SecurityMasterLoadFailure {
    if (error instanceof Error) {
        return {
            name: error.name,
            message: error.message,
            transient: error instanceof SecurityMasterLoadError || error instanceof ZodError,
        };
    }
    return { name: 'Error', message: String(error), transient: false };
}

export function deserializeLoadFailure(failure: SecurityMasterLoadFailure): Error {
    if (failure.transient) {
        return new SecurityMasterLoadError(
            failure.name === 'SecurityMasterLoadError' ? failure.message : `${failure.name}: ${failure.message}`,
        );
    }
    const error = new Error(failure.message);
    error.name = failure.name;
    return error;
}
